module.exports = __webpack_public_path__ + "media/images/favorite-red-icon-5097477fb7b67f5662e01e04e9ddb085.png";